import { render, staticRenderFns } from "./SurveyClient.vue?vue&type=template&id=fa24f53c&scoped=true&"
import script from "./SurveyClient.vue?vue&type=script&lang=ts&"
export * from "./SurveyClient.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyClient.vue?vue&type=style&index=0&id=fa24f53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa24f53c",
  null
  
)

export default component.exports